import { Component } from 'react';
import { MatrixHeaderCellElement, SortAscendingIcon, SortDescendingIcon } from './style';
import { Bordered, Emphasized, Highlighted, MatrixMainMapping, SortOrder } from './types';

export interface MatrixHeaderCellProps<T> extends MatrixMainMapping<T>, Bordered, Emphasized, Highlighted {
    sortedBy?: boolean;
    sortOrder?: SortOrder;
    sortable?: boolean;
    columnIndex?: number;
    fixedFirstColumn?: boolean;
    onSort?: (columnIndex: number) => void;
}

class MatrixHeaderCell<T> extends Component<MatrixHeaderCellProps<T>> {
    handleClick = () => {
        if (this.props.onSort && this.props.columnIndex) {
            this.props.onSort(this.props.columnIndex);
        }
    };

    render() {
        const {
            columnAlignment,
            title,
            sortable,
            valueKey,
            sortedBy,
            sortOrder,
            bordered,
            emphasized,
            highlighted,
            fixedFirstColumn,
        } = this.props;

        const cellProps = {
            bordered,
            columnAlignment,
            sortable,
            sortedBy,
            emphasized,
            highlighted,
            fixedFirstColumn,
            onClick: sortable ? this.handleClick : () => {},
        };

        let sortIcon;
        if (sortedBy) {
            sortIcon = sortOrder === SortOrder.Ascending ? <SortAscendingIcon /> : <SortDescendingIcon />;
        }

        return (
            <MatrixHeaderCellElement {...cellProps}>
                {sortIcon}
                {title || valueKey.toString()}
            </MatrixHeaderCellElement>
        );
    }
}

export default MatrixHeaderCell;
